<div class="container">
    <div class="row">
        <!-- Data -->
        <div class="col-sm-3" *ngFor="let item of clients">
            <div class="sigma_client">
                <img [src]="item.image" alt="client">
            </div>
        </div>
        <!-- Data -->
    </div>
</div>